{
  "zh-CN": {
    "sublines": {
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "免责声明",
        "copyright": "版权",
        "thirdpartycontent": "点数",
        "sponsors": "赞助商",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      }
    }
  }
}
